import Button from 'components/button/Button'
import React, { useState } from 'react'
import { ActionButtonsWrapper } from './elementStyled'

interface OPERATION_PROPS {
  colors: any
  handleSetStake: any
  audio: any
  SFX: any
  handleAbove: any
}

export default function ActionButtons({
  colors,
  SFX,
  audio,
  handleSetStake,
  handleAbove,
}: OPERATION_PROPS) {
  const [anim, setanim] = useState(false)

  const clickHandler = () => {
    SFX.goBackSFX.play()
    setanim(true)
    setTimeout(() => {
      handleAbove(false)
      setanim(false)
    }, 320)
  }
  return (
    <ActionButtonsWrapper textColor={colors.secondary} anim={anim}>
      <Button
        func={handleSetStake}
        audio={audio}
        SFX={SFX.confirmSFX}
        textColor={colors.tertiaryDark}
        background={colors.secondary}
        width='100%'
        size='18px'
      >
        set stake
      </Button>
      <p onClick={() => clickHandler()}> Back </p>
    </ActionButtonsWrapper>
  )
}
